import * as React from "react";
import { Alarm, alarmSeverity, alarmSeverityColors } from "../api/dataTypes";
import ReactTable from "react-table";
import 'react-table/react-table.css'
import * as TableStyles from "../styles/TableFormats";
import "../styles/Tables.css";
import moment from 'moment';
import matchSorter from 'match-sorter';

interface State {

}

export interface Props {
    alarms: Alarm[] | null;
    loading: boolean;
    //ackAlarm: (alarm: Alarm) => void;
}

export class AlarmsTable extends React.Component<Props, State> {
    // Time zone offset from API server
    private offset = moment().utcOffset();
    
    constructor(props: Props) {
        super(props);
        this.state = {
        };
    }

    getTrProps = (state: any, rowInfo: any, instance: any) => {
        if (rowInfo) {
            return {
                style: {
                    background: alarmSeverityColors[rowInfo.original.severity],
                }
            }
        }
        return {};
    }

    render() {
        return (
            <div className="ReactTable component-standard">
                <ReactTable
                    data={this.props.alarms || undefined}
                    filterable={true}
                    defaultFilterMethod={(filter, row) => (matchSorter([row[filter.id]], filter.value).length !== 0)}

                // COLUMNS ////////////////////////////////
                columns={[{
                    Header: 'Active Time',
                    id: 'raisedTime',
                    accessor: row => moment(row.raisedTime).format('x'),
                    Cell: row => (moment(row.original.raisedTime).add(this.offset,'m').format(' hh:mm a, MM/DD/YY')),
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: TableStyles.dataStyle,
                    width: 180,
                }, {
                    Header: 'Alarm',
                    accessor: 'message',
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: TableStyles.dataStyle,
                    // width: 300
                }, {
                    Header: 'Status',
                    id: 'severity',
                    accessor: (a: Alarm) => {
                        return ( alarmSeverity[a.severity])
                    },
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: TableStyles.dataStyle,
                    width: 150
                }, /*{
                    Header: 'Ackn',
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: {
                        textAlign: "center",
                        padding: "3px"
                    },
                    width: 60,
                    filterable: false,
                    Cell: row => (
                        row.original.severity > 2 &&
                        <div>
                            <button className="iconButton"
                                onClick={() => {
                                    this.props.ackAlarm(row.original);
                                }}
                            >
                                <FontAwesomeIcon icon={faCheckCircle} />
                            </button>
                            
                        </div>
                    )
                },*/ {
                    Header: 'Fault Reset Time',
                    id:'ackTime',
                    accessor: row => moment(row.ackTime!).format('x'),
                    Cell: row => (moment(row.original.ackTime).add(this.offset, 'm').format(' hh:mm a, MM/DD/YY')),
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: TableStyles.dataStyle,
                    width: 180
                }, 
            ]}
                // COLUMNS END //////////////////
                className="-highlight"
                showPagination={false}
                defaultSorted = {[{id: 'raisedTime', desc: true}]}
                minRows={5}
                loading={this.props.loading}
                getTrProps={this.getTrProps}
            />
        </div>
      );
    }

}